"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Grid_1 = __importDefault(require("@mui/material/Grid"));
const ComponentsTable_1 = __importDefault(require("./components/ComponentsTable"));
const ComponentsChangeLog_1 = __importDefault(require("./components/ComponentsChangeLog"));
const Main_1 = __importDefault(require("@/components/Main"));
function ComponentsView() {
    return (react_1.default.createElement(Main_1.default, null,
        react_1.default.createElement(Grid_1.default, { container: true, spacing: 4 },
            react_1.default.createElement(Grid_1.default, { xs: 8, item: true },
                react_1.default.createElement(ComponentsTable_1.default, null)),
            react_1.default.createElement(Grid_1.default, { xs: 4, item: true, sx: { marginTop: "70px" } },
                react_1.default.createElement(ComponentsChangeLog_1.default, null)))));
}
exports.default = ComponentsView;
